import { BalloonEventModel } from 'ts-core';
import React from 'react';
import { ContactInfoList } from './ContactInfoList';

export function ContactSection({ event }: { event: BalloonEventModel }) {
    const contacts = event.contacts;

    if (!contacts || contacts.length === 0) return null;

    return (
        <div className="balloon-section contact-section flex flex-col gap-2">
            <ContactInfoList contacts={contacts} />
        </div>
    );
}
